import React, { SVGProps } from 'react';

export const ArrowCounterClockwiseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#a)">
      <path d="M2.7 12a9.301 9.301 0 0 0 13.671 8.21 9.3 9.3 0 0 0 3.765-3.71H16.2v-1.8h6.9v6.9h-1.8v-3.542A11.099 11.099 0 0 1 .9 12h1.8ZM6.783 2.203A11.1 11.1 0 0 1 23.1 12h-1.8A9.301 9.301 0 0 0 7.629 3.792 9.298 9.298 0 0 0 3.864 7.5H7.8v1.8H.9V2.4h1.8v3.541a11.1 11.1 0 0 1 4.083-3.738Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
